module.exports = __webpack_public_path__ + "img/img5.ac7f0b08.png";